module.exports = __WEBPACK_EXTERNAL_MODULE_70__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"ReactBootstrap","commonjs2":"react-bootstrap","commonjs":"react-bootstrap","amd":"react-bootstrap"}
 ** module id = 70
 ** module chunks = 0
 **/